module.exports = __webpack_public_path__ + "assets/me.5adc9286.jpg";